import { MintDTO } from "./../pages/Mint/types";
import httpService from "./httpService";
import apiUrl from "../configs/api";

export function mint(data: MintDTO, token: string): Promise<any> {
  const formData = new FormData();
  formData.append("dto", JSON.stringify(data));
  return httpService.post(`${apiUrl}mint`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  });
}

export function shortenLink(longUrl: string): Promise<any> {
  const bitlyToken = "62844b588d7152e7d5c4ceab460adf4f1a2c9a7f";
  const url = `https://api-ssl.bitly.com/v4/shorten`;
  const headers = {
    Authorization: `Bearer ${bitlyToken}`,
    "Content-Type": "application/json",
  };
  const data = {
    long_url: longUrl,
    domain: "bit.ly",
  };

  return httpService.post(url, data, { headers });
}
